import React from 'react';
import { CoreMarketplaceCombinedMarketplaceSearch, Ad } from '../../schemas/rql';
import ErrorDisplay from '../discovery/error_display';
import { PageSettings } from './map_params';
import InterspersedListings from './interspersed_listings';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import CombinedBumpListingGrid from './combined_bump_listing_grid';

interface ExternalProps {
  useListView: boolean;
  listings: CoreMarketplaceCombinedMarketplaceSearch.Listings[];
  bumpedListings: CoreMarketplaceCombinedMarketplaceSearch.Listings[];
  error: Error;
  loading: boolean;
  showOnlySold?: boolean;
  trackingQuery?: string;
  ad?: Ad;
  pageSettings?: PageSettings;
}

type Props = ExternalProps & IUserContext;

export function ListingsWithBumps(props: Props) {
  if (props.error) return <ErrorDisplay />;

  if (props.useListView) {
    return (
      <ul>
        <InterspersedListings
          user={props.user}
          listings={props.listings}
          bumpedListings={props.bumpedListings}
          showOnlySold={props.showOnlySold}
          trackingQuery={props.trackingQuery}
          ad={props.ad}
          pageSettings={props.pageSettings}
          displayAsRows
          loading={props.loading}
        />
      </ul>
    );
  }

  return (
    <>
      <CombinedBumpListingGrid
        error={props.error}
        listings={props.listings}
        bumpedListings={props.bumpedListings}
        loading={props.loading}
        trackingQuery={props.trackingQuery}
        ad={props.ad}
        pageSettings={props.pageSettings}
      />
    </>
  );
}

export default withUserContext<ExternalProps>(ListingsWithBumps);
